var _style, _path, _g, _circle, _g2, _defs, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDekraCert = function SvgDekraCert(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247.8 349",
    style: {
      enableBackground: "new 0 0 247.8 349"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008143;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#008143;}\n\t.st3{clip-path:url(#SVGID_00000165223889437214715040000010243234031957245316_);}\n\t.st4{fill:none;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000182494258482388620900000003495763848583743369_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_877",
    className: "st0",
    d: "M123.8,349c67.5,0,122.3-54.7,122.3-122.3s-54.7-122.3-122.3-122.3S1.5,159.2,1.5,226.7 c0,0,0,0,0,0l0,0C1.6,294.2,56.3,349,123.8,349L123.8,349"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1861"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_33",
    x: 1.5,
    className: "st0",
    width: 244.5,
    height: 225.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 124.4,
    cy: 227,
    r: 98
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-3"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_880",
    className: "st2",
    d: "M51,234.1h1.3c8.9,0,13.3,4.5,13.3,13.2c0,7.9-3.7,13.2-13.3,13.2H51L51,234.1z  M43.2,267.3h11.1c11-0.5,19.6-9.8,19.1-20.8c-0.4-10.4-8.8-18.7-19.1-19.1H43.2V267.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_881",
    className: "st0",
    d: "M99.2,234.1v-6.8H78.5v39.9h20.7v-6.8H86.3v-10.8h12.4v-6.8H86.3v-8.8H99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_882",
    className: "st2",
    d: "M181.1,252.5l4.8-14.4l0,0l4.5,14.4H181.1z M167.4,267.3l15-38.6c0.6-1.5,1.9-2.5,3.5-2.5 c1.6,0,3,1,3.5,2.5l14.5,38.6h-8l-2.9-8.4h-14l-3.3,8.4L167.4,267.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_883",
    className: "st0",
    d: "M113.9,244.2L113.9,244.2v-16.8H106v39.9h7.8v-18l0,0l12.8,18h10.2l-16.1-21.5l15.1-18.4 h-9.6L113.9,244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_884",
    className: "st0",
    d: "M156.4,251l10.9,16.3H158l-9.8-16.1v16.1h-7.9v-39.9h13.4c6.6,0,11.9,5.4,11.9,12 c0,5.5-3.8,10.3-9.2,11.6 M152.2,233.7h-4.1v12h4.2c3.3-0.3,5.8-3.2,5.6-6.5c-0.2-3-2.6-5.3-5.6-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_885",
    className: "st0",
    d: "M109.9,147.6l33.9,19.6c5,3,6.5,9.5,3.5,14.4c-0.9,1.4-2.1,2.6-3.5,3.5l-46.4,26.7v-11.9 l41-23.8l-22.1-12.8v18l-10.5,6v-37.5c0-1.4,1.2-2.6,2.6-2.6c0,0,0,0,0,0h0.3c0.5,0,0.9,0.1,1.3,0.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 4.9,
    width: 247.8,
    height: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072264313410615815820000003542453079626626450_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072264313410615815820000003542453079626626450_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1864"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_294",
    className: "st4",
    x1: 246.1,
    y1: 6.5,
    x2: 1.5,
    y2: 6.5
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_887",
    className: "st5",
    d: "M215.1,35.1h1.7V33h-1.7v-3.5H213V33h-0.9v2.1h0.9v7h2.1V35.1z M202.4,33v9.1h2.1v-4.4 c0-2.3,0.5-3.1,2-3.1c0.6,0,1.1,0.2,1.4,0.7c0.2,0.6,0.3,1.2,0.3,1.8v5.1h2.2v-5.6c0.1-0.9-0.1-1.8-0.6-2.6 c-0.7-0.9-1.8-1.3-2.9-1.2c-1,0-1.9,0.4-2.5,1.1V33H202.4z M193.6,36.5c0.2-1,1.1-1.7,2.1-1.7c1,0,1.9,0.7,2.1,1.7H193.6z  M200.1,38.2v-0.7c0-1.1-0.2-2.1-0.7-3.1c-1.5-2-4.3-2.4-6.3-0.9c-0.1,0-0.1,0.1-0.2,0.1c-1.1,0.8-1.7,2.1-1.8,3.5 c0,0.2,0,0.4,0,0.6c-0.2,2.4,1.6,4.6,4,4.8c0,0,0,0,0,0h0.5c1.1,0,2.2-0.4,3.1-1.1c0.5-0.4,1-1,1.3-1.6l-1.6-1.3 c-0.9,1.4-1.4,1.8-2.5,1.8c-1.3,0-2.3-1.1-2.3-2.4l0,0L200.1,38.2z M176.4,33v9.1h2.1v-4.7c0-0.7,0.1-1.4,0.3-2 c0.3-0.5,0.9-0.8,1.4-0.8c0.9,0,1.4,0.8,1.4,2.5v5h2.1v-4.7c0-1.9,0.5-2.8,1.7-2.8c1.2,0,1.4,0.7,1.4,2.5v5h2.1v-5.6 c0-0.8-0.1-1.6-0.5-2.3c-0.6-1-1.6-1.6-2.7-1.5c-1.1,0-2.1,0.5-2.7,1.4c-0.5-0.9-1.5-1.4-2.5-1.4c-0.9,0-1.7,0.4-2.2,1.1V33 H176.4z M167.7,36.5c0.2-1,1.1-1.7,2.1-1.7c1,0,1.9,0.7,2,1.7H167.7z M174.1,38.2v-0.7c0-1.1-0.2-2.1-0.7-3.1 c-1.5-2-4.4-2.3-6.3-0.8c0,0,0,0,0,0c-1.1,0.8-1.7,2.1-1.8,3.5v0.6c-0.2,2.4,1.6,4.6,4,4.8c0,0,0,0,0,0h0.6 c1.1,0,2.2-0.4,3.1-1.1c0.5-0.4,0.9-1,1.3-1.6l-1.8-1.3c-0.9,1.4-1.4,1.8-2.5,1.8c-1.3,0-2.3-1.1-2.3-2.3l0,0L174.1,38.2z  M158.4,34.7c1.6,0.2,2.8,1.6,2.6,3.3c-0.2,1.4-1.2,2.5-2.6,2.6c-0.7,0-1.3-0.3-1.8-0.7c-0.5-0.6-0.8-1.4-0.7-2.2 c-0.2-1.4,0.8-2.7,2.2-2.9L158.4,34.7L158.4,34.7z M163,33h-2.1V34c-0.7-0.8-1.8-1.3-2.9-1.3c-2.5,0.1-4.4,2.2-4.3,4.7 c0,0,0,0,0,0l0,0v0.2c-0.2,2.4,1.6,4.5,4.1,4.7h0.2c1.1,0,2.2-0.5,2.9-1.3v1.3c0.1,0.7-0.1,1.3-0.4,1.9 c-0.4,0.6-1.1,0.9-1.9,0.9c-0.8,0-1.6-0.4-2.1-1.1c-0.2-0.5-0.4-1-0.4-1.5h-1.9c-0.1,2.1,1.4,4,3.5,4.3h0.6 c1.4,0,2.7-0.7,3.5-1.8c0.7-1,0.9-2.3,0.8-3.5L163,33z M146.9,34.6c1.6-0.2,3.1,1,3.3,2.6s-1,3.1-2.6,3.3 c-1.6,0.2-3-0.9-3.3-2.4v-0.5c-0.1-1.5,1-2.8,2.4-2.9c0,0,0,0,0,0l0,0L146.9,34.6z M149.4,33V34c-0.7-0.9-1.8-1.4-2.9-1.3 c-2.7,0.3-4.6,2.8-4.3,5.5c0.3,2.2,2,4,4.3,4.3c1.1,0,2.1-0.5,2.8-1.3v0.9h2.1V33H149.4z M131.8,33v9.1h2.1v-4.4 c0-2.3,0.5-3.1,2-3.1c0.6,0,1.1,0.2,1.4,0.7c0.3,0.5,0.4,1.2,0.3,1.8v5.1h2.1v-5.6c0.1-0.9-0.1-1.8-0.6-2.6 c-0.6-0.7-1.5-1.2-2.4-1.2c-1,0-1.9,0.4-2.5,1.1V33H131.8z M124.5,34.6c1.6-0.3,3.2,0.8,3.5,2.4c0,0.1,0,0.1,0,0.2 c0.3,1.6-0.8,3.2-2.5,3.4c-1.6,0.3-3.2-0.8-3.4-2.5l0,0c0-0.1,0-0.3,0-0.5c-0.1-1.4,0.9-2.7,2.4-2.9c0,0,0,0,0,0l0,0V34.6z  M127.2,33V34c-0.7-0.9-1.8-1.4-2.9-1.3c-2.7,0.4-4.5,2.9-4.2,5.5c0.3,2.2,2.1,3.9,4.2,4.2c1.1,0,2.1-0.5,2.8-1.3v0.9h2.1V33 H127.2z M105.2,33v9.1h2.1v-4.7c0-0.7,0.1-1.4,0.3-2c0.3-0.5,0.8-0.8,1.4-0.8c1,0,1.4,0.8,1.4,2.5v5h2.1v-4.7 c0-1.9,0.5-2.8,1.7-2.8c1.2,0,1.5,0.7,1.5,2.5v5h2.1v-5.6c0-0.8-0.1-1.6-0.4-2.3c-0.6-0.9-1.6-1.5-2.7-1.5 c-1.1,0-2.1,0.5-2.7,1.4c-0.5-0.9-1.5-1.4-2.5-1.4c-0.9,0-1.7,0.4-2.2,1.1V33H105.2z M102.7,34.5c-0.6-1.4-2.2-2.1-3.7-1.6 c-1,0.4-1.8,1.4-1.8,2.5c0,1.1,0.4,1.7,1.8,2.4c2,1,2.1,1.1,2.1,1.7c0,0.5-0.4,1-1,1l0,0c-0.7,0-1-0.3-1.5-1.2l-1.8,0.8 c0.5,1.4,1.8,2.3,3.3,2.3c1.7,0.1,3.2-1.3,3.3-3c0,0,0,0,0,0l0,0l0,0c0-1.3-0.6-2-2.8-3c-1-0.5-1.2-0.7-1.2-1.1 c0-0.4,0.3-0.7,0.7-0.7l0,0l0,0c0.5,0,0.8,0.2,1.1,0.8L102.7,34.5z M94.2,35.1h1.7V33h-1.7v-3.5h-2.1V33h-0.9v2.1h0.9v7h2.1 V35.1z M87.2,28.8c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v0l0,0c0.1-0.8-0.5-1.4-1.3-1.5 c0,0,0,0-0.1,0V28.8z M83.2,28.8c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v0l0,0 c0.1-0.8-0.5-1.4-1.3-1.5c0,0,0,0-0.1,0L83.2,28.8z M84.9,34.7c1.6-0.2,3.1,1,3.3,2.6s-1,3.1-2.6,3.3c-1.6,0.2-3-0.9-3.3-2.4 v-0.5c-0.1-1.5,1-2.8,2.4-2.9c0,0,0,0,0,0l0,0L84.9,34.7z M87.2,33.1v1.1c-0.7-1-1.8-1.6-3.1-1.5c-2.6,0.5-4.4,2.9-4,5.6 c0.3,2.2,2.1,3.9,4.2,4.2c1.1,0,2.1-0.5,2.8-1.3v0.9h2.1V33L87.2,33.1z M77.1,35.1h1.7V33h-1.7v-3.5H75V33h-0.9v2.1H75v7h2.1 V35.1z M71.2,28.1c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.7,1.4,1.4,1.4c0.8,0,1.4-0.7,1.4-1.4c0,0,0,0,0,0l0,0c0-0.4-0.1-0.7-0.4-1 c-0.2-0.3-0.5-0.5-0.8-0.5L71.2,28.1z M72.4,33.1h-2.2v8.9h2.1L72.4,33.1z M67.6,26.2h-2.1v15.9h2.1V26.2z M58.1,34.6 c1.6-0.3,3.2,0.8,3.5,2.4c0,0.1,0,0.1,0,0.2c0.3,1.6-0.8,3.2-2.5,3.4c-1.6,0.3-3.2-0.8-3.4-2.5l0,0v-0.5 c-0.1-1.5,1-2.8,2.5-2.9L58.1,34.6z M60.7,33V34c-0.7-0.9-1.8-1.4-2.9-1.3c-2.7,0.4-4.5,2.9-4.1,5.6c0.3,2.1,2,3.8,4.1,4.1 c1.1,0,2.1-0.5,2.8-1.3v0.9h2.1V33H60.7z M45.6,33h-2.1v5.3c-0.1,1.1,0.2,2.2,0.9,3c0.8,0.8,1.8,1.2,2.9,1.2 c1.9,0.2,3.7-1.1,3.9-3.1c0-0.2,0-0.3,0-0.5c0-0.3,0-0.5,0-0.8V33h-2.2v5.3c0,0.5,0,1-0.3,1.5c-0.6,0.8-1.7,1.1-2.6,0.5 c-0.3-0.1-0.5-0.3-0.7-0.6c-0.1-0.5-0.1-1,0-1.5L45.6,33z M35.3,36.5h-2.8l3.5,3.3c-2.1,1.2-4.6,0.8-6.3-0.9 c-1.1-1-1.6-2.4-1.6-3.8c-0.2-2.9,2.1-5.4,5-5.6h0.3c3,0,5.4,2.3,5.4,5.3l0,0v0.3c0,1.3-0.5,2.6-1.4,3.5L35.3,36.5z  M41.3,42.5L38.9,40c1.4-1.3,2.1-3.1,2.1-4.9c-0.3-4.2-3.9-7.4-8.1-7.1c-3.8,0.3-6.8,3.3-7.1,7.1l0,0c-0.1,1.8,0.6,3.6,1.8,5 c1.5,1.6,3.5,2.6,5.8,2.6c1.4,0,2.9-0.4,4.1-1.2l1.1,1.2L41.3,42.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_38",
    x: 26.5,
    y: 51.7,
    className: "st1",
    width: 2.2,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_888",
    className: "st5",
    d: "M40.5,54c-0.7-1.5-2.2-2.5-3.9-2.5c-2.2-0.2-4.2,1.5-4.3,3.8l0,0c0,1.6,0.9,2.8,2.9,3.7 c0.9,0.3,1.7,0.7,2.5,1.2c0.7,0.4,1,1.1,1,1.9c0,1.3-1.1,2.4-2.5,2.4c0,0,0,0,0,0l0,0c-0.8,0-1.6-0.4-2-1.1 c-0.3-0.5-0.4-1-0.4-1.6l-2.2,0.5c0.2,2.6,2.4,4.5,5,4.4c0.9-0.1,1.7-0.4,2.4-0.8c1.1-0.8,1.9-2.1,2-3.5V62 c0-2-1.1-3.3-3.5-4.3c-0.8-0.3-1.6-0.6-2.4-1.1c-0.4-0.3-0.7-0.7-0.7-1.2c0.1-1.1,1-1.9,2-1.8c0,0,0,0,0,0l0,0 c1,0,1.5,0.3,2.2,1.4L40.5,54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_889",
    className: "st5",
    d: "M50.4,53.5c3,0.2,5.3,2.9,5,5.9c-0.2,2.7-2.4,4.8-5,5c-1.4,0-2.7-0.6-3.7-1.5 c-1.1-1-1.7-2.5-1.6-4C45,56,47.4,53.5,50.4,53.5C50.4,53.5,50.4,53.5,50.4,53.5z M50.4,51.4c-4.1,0-7.5,3.4-7.6,7.5 c0,1.9,0.6,3.7,1.8,5c1.5,1.6,3.5,2.5,5.7,2.6c4.2,0.2,7.8-3,8-7.1c0.2-4.1-2.9-7.7-7-8C51.3,51.4,50.4,51.4,50.4,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_890",
    className: "st5",
    d: "M70.6,53.4c1.5,0,2.8,1.2,2.9,2.7c0,1.5-1.2,2.8-2.7,2.9c-1.5,0-2.8-1.2-2.9-2.7l0,0l0,0 C67.9,54.7,69.1,53.5,70.6,53.4z M69,66.8l5.1-7c0.9-1,1.4-2.3,1.4-3.7c-0.2-2.7-2.6-4.7-5.3-4.5c-2.4,0.2-4.3,2.1-4.5,4.5 l0,0c-0.2,2.5,1.6,4.7,4,4.9c0.1,0,0.2,0,0.3,0h0.9l-3.5,4.8L69,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_891",
    className: "st5",
    d: "M83.1,53.4c0.9,0,1.7,0.6,2.1,1.4c1.2,2.6,1.2,5.6,0,8.2c-0.4,0.8-1.2,1.4-2.1,1.4 c-0.9,0-1.7-0.6-2.1-1.4c-1.2-2.6-1.2-5.6,0-8.2C81.4,54,82.2,53.4,83.1,53.4z M83.1,51.4c-3,0-5.2,3.2-5.2,7.4 c-0.1,1.9,0.4,3.8,1.3,5.4c1.2,2.1,3.8,2.9,5.9,1.7l0,0c0.7-0.4,1.3-1,1.6-1.7c0.9-1.6,1.4-3.4,1.3-5.3 c0.1-1.9-0.4-3.7-1.3-5.3C86,52.4,84.6,51.5,83.1,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_892",
    className: "st5",
    d: "M95.4,53.4c0.9,0,1.7,0.6,2.1,1.4c0.7,1.3,1,2.7,0.9,4.1c0,1.4-0.3,2.9-0.9,4.1 c-0.4,0.8-1.2,1.4-2.1,1.4c-0.9,0-1.7-0.6-2.1-1.4c-1.2-2.6-1.2-5.6,0-8.2C93.7,54,94.5,53.4,95.4,53.4z M95.4,51.4 c-3,0-5.2,3.2-5.2,7.4c-0.1,1.9,0.4,3.7,1.3,5.4c1.2,2.1,3.8,2.9,6,1.7c0.7-0.4,1.3-1,1.6-1.7c1-1.6,1.4-3.4,1.4-5.3 c0-1.9-0.4-3.7-1.4-5.3C98.4,52.4,97,51.5,95.4,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_893",
    className: "st5",
    d: "M107.1,53.7v12.5h2.2V51.7h-3.5l-1.2,2H107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_894",
    className: "st5",
    d: "M116.8,56.8c-0.7,0-1.3,0.6-1.4,1.3c0,0.7,0.6,1.3,1.3,1.4c0.7,0,1.3-0.6,1.4-1.3l0,0 C118.1,57.4,117.6,56.8,116.8,56.8z M116.8,63.8c-0.7,0-1.3,0.6-1.3,1.3l0,0c0.1,0.7,0.7,1.2,1.4,1.3c0.7,0,1.3-0.6,1.2-1.4 c0,0,0,0,0,0l0,0c0-0.3-0.1-0.7-0.4-0.9C117.5,63.9,117.2,63.8,116.8,63.8L116.8,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_895",
    className: "st5",
    d: "M124.7,64.2l2.3-2.7c2.5-3,3.1-4.1,3.1-5.7c0-2.5-2.1-4.4-4.5-4.4c0,0,0,0,0,0h-0.2 c-1.5-0.1-3,0.7-3.8,1.9c-0.5,0.8-0.8,1.7-0.9,2.6h2.2c0-0.6,0.2-1.1,0.5-1.6c0.8-1.1,2.4-1.3,3.5-0.5c0.6,0.5,1,1.2,1,1.9 c0,0.9-0.5,1.8-2.6,4.3l-5.1,6.1h9.8v-2.1H124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_896",
    className: "st5",
    d: "M138.2,53.4c0.9,0,1.7,0.6,2.1,1.4c1.2,2.6,1.2,5.7,0,8.3c-0.5,1.2-1.8,1.7-2.9,1.3 c-0.6-0.2-1-0.7-1.3-1.3c-1.2-2.6-1.2-5.6,0-8.2C136.4,54,137.2,53.4,138.2,53.4z M138.2,51.4c-3,0-5.2,3.2-5.2,7.4 c-0.1,1.9,0.4,3.7,1.3,5.4c1.2,2.1,3.8,2.9,6,1.7c0.7-0.4,1.3-1,1.7-1.7c0.9-1.6,1.4-3.4,1.3-5.3c0.1-1.9-0.4-3.7-1.3-5.3 C141.2,52.3,139.7,51.5,138.2,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_897",
    className: "st5",
    d: "M149.9,53.7v12.5h2.2V51.7h-3.5l-1.2,2H149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_898",
    className: "st5",
    d: "M167.1,53.7v-2h-6l-2.3,7.6h0.7c0.6-0.8,1.5-1.3,2.6-1.3c1.8,0.2,3.1,1.8,2.9,3.6 c-0.2,1.5-1.4,2.7-2.9,2.9c-0.8,0-1.6-0.3-2.2-0.8c-0.4-0.4-0.7-0.8-0.9-1.3l-1.6,1.4c0.9,1.7,2.6,2.8,4.6,2.7 c2.8,0.1,5.3-2,5.4-4.9v-0.4c0.1-2-1-3.8-2.8-4.7c-0.7-0.3-1.4-0.4-2.1-0.4h-0.6l0.7-2.5L167.1,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_899",
    className: "st5",
    d: "M26.8,87.4h-1.2l3.1,6.8l2-4.7l2,4.7l3.2-6.8h-1.2l-1.9,4.3l-2-4.8l-2,4.8L26.8,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_900",
    className: "st5",
    d: "M37.2,87.4H36l3.1,6.8l2-4.7l1.9,4.7l3.2-6.8H45l-1.9,4.3l-2-4.8l-2,4.8L37.2,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_901",
    className: "st5",
    d: "M47.6,87.4h-1.2l3.1,6.8l2-4.7l2,4.7l3.2-6.8h-1.2l-1.9,4.3l-2-4.8l-2,4.8L47.6,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_902",
    className: "st5",
    d: "M58.5,92.6c-0.4-0.1-0.8,0.2-0.9,0.6c-0.1,0.4,0.2,0.8,0.6,0.9c0.1,0,0.2,0,0.3,0 c0.4,0,0.7-0.3,0.7-0.7l0,0C59.2,92.9,58.9,92.6,58.5,92.6L58.5,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_903",
    className: "st5",
    d: "M64,88.3c1.1,0,2.1,0.9,2.1,2c0,0,0,0,0,0v0.3c0.2,1.2-0.6,2.3-1.8,2.4c0,0,0,0,0,0H64 c-1.2,0-2.2-1-2.1-2.2l0,0c-0.1-1.2,0.8-2.2,2-2.3L64,88.3z M66,82.6v5.7c-0.5-0.7-1.4-1-2.2-1c-1.7,0-3.1,1.4-3.1,3.1v0l0,0 v0.2c-0.2,1.7,1,3.3,2.7,3.5h0.3c0.9,0,1.7-0.4,2.2-1.1v0.9h1.1V82.6H66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_904",
    className: "st5",
    d: "M70.1,89.9c0.1-0.9,0.9-1.6,1.9-1.6c1,0,1.8,0.7,1.9,1.6H70.1z M75,90.9v-0.2 c0.3-1.6-0.8-3.2-2.4-3.5H72c-1.7,0.3-3,1.8-3,3.5c0.1,1.6,1.4,2.9,3,3c1.2,0,2.4-0.7,2.9-1.8l-0.9-0.7c-0.6,1-1.1,1.3-2,1.3 c-1.1,0-2-0.9-2-2l0,0L75,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_905",
    className: "st5",
    d: "M77.7,82.6h-1.1v11.2h1.1v-2.6l0.3-0.3l2.6,2.9h1.4l-3.2-3.5l2.7-2.7H80l-2.3,2.3V82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_906",
    className: "st5",
    d: "M83.1,87.4v6.3h1.1v-3.3c0-1.5,0.4-2.1,1.2-2.1c0.2,0,0.5,0.1,0.7,0.2l0.5-1 c-0.3-0.2-0.6-0.3-0.9-0.3c-0.6,0-0.9,0.2-1.4,0.8v-0.7L83.1,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_907",
    className: "st5",
    d: "M90.3,88.2c1.2,0,2.1,1,2.1,2.1c0,0,0,0,0,0l0,0v0.2c0.1,1.2-0.7,2.3-1.9,2.4h-0.2 c-1.2,0-2.1-0.9-2.1-2.1c0,0,0,0,0-0.1l0,0l0,0c-0.1-1.2,0.8-2.2,2-2.3L90.3,88.2z M92.4,87.4v0.9c-0.5-0.7-1.4-1.1-2.2-1.1 c-1.7,0-3.1,1.4-3.1,3.1v0l0,0v0.2c-0.2,1.7,0.9,3.2,2.6,3.5c0.1,0,0.1,0,0.2,0h0.2c0.9,0,1.7-0.4,2.2-1.1v0.9h1.1v-6.5 L92.4,87.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_39",
    x: 94.5,
    y: 90,
    className: "st1",
    width: 2.8,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_908",
    className: "st5",
    d: "M101.9,88.4c-0.3-0.7-1-1.1-1.7-1.1c-1-0.1-1.9,0.6-2,1.6c0,0,0,0,0,0l0,0l0,0 c0,0.8,0.4,1.2,1.9,1.9c0.8,0.4,1.1,0.6,1.1,1.1c0,0.6-0.5,1-1,1h0l0,0c-0.6,0-0.9-0.2-1.3-1.1l-1,0.4c0.3,1,1.2,1.6,2.3,1.6 c1.1,0,2.1-0.8,2.1-2l0,0c0-1-0.4-1.4-1.9-2c-0.9-0.4-1.1-0.5-1.1-0.9c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0.1,0l0,0 c0.4,0,0.7,0.3,0.9,0.6L101.9,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_909",
    className: "st5",
    d: "M104.2,84.2c-0.4,0-0.8,0.3-0.8,0.8l0,0c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8l0,0l0,0 C105,84.5,104.7,84.2,104.2,84.2z M104.8,87.3h-1.1v6.4h1.1V87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_910",
    className: "st5",
    d: "M107.7,89.9c0.1-1,1-1.8,2.1-1.6c0.9,0.1,1.6,0.8,1.6,1.6H107.7z M112.6,90.9v-0.2 c0.3-1.7-0.9-3.2-2.5-3.5c0,0,0,0,0,0h-0.5c-1.8,0.6-2.8,2.6-2.2,4.4c0.3,1.1,1.2,1.9,2.2,2.2c1.2,0,2.4-0.7,2.9-1.8 l-0.9-0.5c-0.6,1-1.1,1.3-2,1.3c-1.1,0-2-0.9-2-2l0,0L112.6,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_911",
    className: "st5",
    d: "M117,88.2c1.3-0.2,2.5,0.8,2.7,2.1s-0.8,2.5-2.1,2.7c-1.3,0.1-2.5-0.8-2.7-2.1v-0.3 c-0.1-1.2,0.7-2.2,1.8-2.3L117,88.2L117,88.2z M120.2,87.4h-0.9v0.9c-0.5-0.7-1.3-1.1-2.2-1.1c-1.7,0-3.1,1.4-3.1,3.2 c0,0,0,0,0,0l0,0v0.2c-0.1,1.7,1.1,3.1,2.8,3.3h0.2c0.9,0,1.7-0.4,2.2-1.1v0.9c0,1.6-0.7,2.5-2,2.5c-1,0.1-2-0.7-2-1.7 c0,0,0,0,0,0l0,0v-0.2h-1.1c-0.1,1.6,1.1,2.9,2.7,2.9h0.4c1,0,1.9-0.4,2.5-1.2c0.5-0.7,0.7-1.6,0.6-2.5L120.2,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_912",
    className: "st5",
    d: "M123.1,89.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9H123.1z M128,90.9v-0.2 c0.3-1.7-0.9-3.2-2.5-3.5c0,0,0,0,0,0H125c-1.8,0.6-2.8,2.6-2.2,4.4c0.3,1.1,1.2,1.9,2.2,2.2c1.2,0,2.4-0.7,2.9-1.8l-0.9-0.5 c-0.6,1-1.1,1.3-2,1.3c-1.1,0-2-0.9-2-2l0,0L128,90.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_40",
    x: 129.6,
    y: 82.6,
    className: "st1",
    width: 1.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_913",
    className: "st5",
    d: "M133.5,92.6c-0.4,0-0.7,0.3-0.7,0.7l0,0c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.8-0.3,0.8-0.8l0,0 l0,0c0-0.2-0.1-0.4-0.2-0.5C133.8,92.6,133.6,92.6,133.5,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_914",
    className: "st5",
    d: "M139,88.3c1.1,0,2.1,0.9,2.1,2c0,0,0,0,0,0v0.3c0.1,1.2-0.7,2.3-1.9,2.4H139 c-1.2,0-2.1-1-2.1-2.2c0,0,0,0,0,0l0,0c-0.1-1.2,0.8-2.2,2-2.3L139,88.3z M141.1,82.6v5.7c-0.5-0.7-1.4-1-2.2-1 c-1.7,0-3.1,1.4-3.1,3.1l0,0v0.2c-0.2,1.7,1,3.3,2.7,3.5l0,0c0.9,0,1.7-0.4,2.2-1.1v0.9h1.1V82.6H141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_915",
    className: "st5",
    d: "M145.1,89.9c0.2-0.9,0.9-1.6,1.9-1.6c0.9,0,1.8,0.7,1.9,1.6H145.1z M150,90.9v-0.2 c0.3-1.7-0.9-3.2-2.5-3.5c0,0,0,0,0,0H147c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.2,0,2.4-0.7,2.9-1.8l-0.9-0.5 c-0.6,1-1.1,1.3-2,1.3c-1.1,0-2-0.9-2-2l0,0L150,90.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_916",
    className: "st2",
    d: "M71.3,300.8l11.7-3.3l-9.3-6.5l-1.5,2.1l5,3.5l-11.7,3.3l10.3,7l1.3-1.9L71.3,300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_917",
    className: "st2",
    d: "M84.9,303.3c0.8-1.1,2.3-1.5,3.5-0.8c1.3,0.5,1.9,1.9,1.6,3.2L84.9,303.3z M91.6,309 l0.3-0.6c0.6-1.2,0.9-2.6,0.8-4c-0.3-1.8-1.5-3.4-3.3-4.1c-3.3-1.1-6.9,0.6-8.1,4c-1,2.9,0.2,6,2.8,7.5 c1.3,0.6,2.8,0.8,4.3,0.4c0.8-0.2,1.6-0.6,2.3-1.2l-1.5-2.2c-1.8,1.2-2.7,1.3-3.9,0.7c-1.5-0.7-2.2-2.6-1.5-4.1l0,0L91.6,309 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_918",
    className: "st2",
    d: "M97.2,303.7l-3.5,11.4l2.6,0.8l1.9-6c0.7-2.2,1.7-3.1,3.2-2.6c0.5,0.2,1,0.5,1.3,1l2-2 c-0.5-0.7-1.2-1.2-2-1.4c-1-0.3-2.2-0.1-3.1,0.5l0.3-1L97.2,303.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_919",
    className: "st2",
    d: "M108.4,309.4l2.1,0.4l0.5-2.5l-2.1-0.4l0.9-4.3l-2.7-0.5l-0.9,4.4l-1-0.4l-0.5,2.5 l1.2,0.2l-2,9.2l2.7,0.6L108.4,309.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_920",
    className: "st2",
    d: "M114.9,301c-1-0.3-1.9,0.3-2.2,1.2c-0.3,1,0.3,1.9,1.2,2.2c0.2,0.1,0.4,0.1,0.6,0.1 c1,0,1.8-0.9,1.7-1.9C116.2,301.9,115.7,301.2,114.9,301L114.9,301z M115.5,308l-2.7-0.4l-1.4,11.9l2.7,0.4L115.5,308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_921",
    className: "st2",
    d: "M121.7,310.9h3v-2.6h-3v-3.9c0-2,0.4-2.5,1.3-2.5c0.9,0.1,0.7,0,1.8,0.6v-2.8 c-1.7-0.8-3.7-0.6-5,0.7c-0.7,0.9-1,2-0.9,3.2v4.6h-1v2.6h1l-0.4,9.4h2.8L121.7,310.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_922",
    className: "st2",
    d: "M127.4,301.6c-1,0.1-1.7,0.9-1.7,1.9c0,0,0,0,0,0l0,0c0.1,1,0.9,1.7,1.9,1.7c0,0,0,0,0,0 l0,0c1-0.1,1.7-0.9,1.7-1.9c0,0,0,0,0,0l0,0c0-0.5-0.2-0.9-0.6-1.2C128.4,301.7,127.9,301.5,127.4,301.6z M129.1,308.3h-2.9 l0.5,12h3L129.1,308.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_923",
    className: "st2",
    d: "M138,316.6l6.1-10.5l-11.4,1.9l0.4,2.6l6-1L133,320l12.4-2.1l-0.5-2.4L138,316.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_924",
    className: "st2",
    d: "M145.2,298.5c-0.9,0.3-1.5,1.3-1.2,2.2c0.3,0.9,1.3,1.5,2.2,1.2c0.9-0.3,1.5-1.3,1.2-2.2 c0,0,0,0,0,0l0,0c-0.1-0.4-0.4-0.8-0.8-1C146.2,298.4,145.7,298.3,145.2,298.5z M148.5,304.6l-2.7,0.8l3.5,11.5l2.7-0.8 L148.5,304.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_925",
    className: "st2",
    d: "M155.8,306.5c-0.3-1.3,0.4-2.6,1.6-3.1c1.2-0.6,2.7-0.2,3.5,0.9L155.8,306.5z  M164.3,305.1l-0.2-0.6c-0.5-1.3-1.4-2.4-2.5-3.3c-1.6-1-3.6-1.1-5.3-0.3c-3.1,1.6-4.3,5.5-2.7,8.6c1.5,2.8,4.8,4.1,7.8,3 c1.4-0.4,2.5-1.3,3.3-2.5c0.4-0.8,0.6-1.6,0.7-2.5l-2.7-0.3c-0.3,2.1-0.8,2.9-2.1,3.5c-1.6,0.7-3.4,0-4.1-1.6c0,0,0,0,0,0 l0,0L164.3,305.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_926",
    className: "st2",
    d: "M164.1,297.8l6.3,10.2l2.3-1.4l-3.3-5.3c-1.2-2-1.2-3.3,0-4.1c0.5-0.3,1.1-0.4,1.6-0.3 l-0.2-2.8c-0.8-0.1-1.7,0.1-2.3,0.6c-0.9,0.6-1.5,1.6-1.6,2.7l-0.6-0.9L164.1,297.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_927",
    className: "st2",
    d: "M175.8,293.1l1.8-1.3l-1.6-2.1l-1.7,1.3l-2.7-3.5l-2.2,1.7l2.6,3.5l-0.9,0.7l1.6,2.1 l0.9-0.7l5.7,7.5l2.2-1.6L175.8,293.1z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDekraCert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dekra-cert.64f2b60.svg";